import { render, staticRenderFns } from "./ContactRemark.vue?vue&type=template&id=af723472"
import script from "./ContactRemark.vue?vue&type=script&lang=js"
export * from "./ContactRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af723472')) {
      api.createRecord('af723472', component.options)
    } else {
      api.reload('af723472', component.options)
    }
    module.hot.accept("./ContactRemark.vue?vue&type=template&id=af723472", function () {
      api.rerender('af723472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactRemark.vue"
export default component.exports